<template>
<div class="wrap">
    <!-- <div class="con"> -->
        <!-- <div class="left-templet" v-show="!isInit">
            <ul>
                <li class="pointer" @click="movePage('/user/reg/terms')" :class="{'on' : progressStyle('/user/reg/terms')}">
                    <a>신청 동의</a>
                </li>
                <li class="pointer" @click="movePage('/user/reg/info')" :class="{'on' : progressStyle('/user/reg/info')}">
                    <a>신청 안내</a>
                </li>
                <li class="pointer" @click="movePage('/user/reg/select')" :class="{'on' : progressStyle('/user/reg/select')}">
                    <a>클래스 선택</a>
                </li>
                <li class="pointer" @click="movePage('/user/reg/input')" :class="{'on' : progressStyle('/user/reg/input')}">
                    <a>정보입력</a>
                </li>
                <li class="pointer" @click="movePage('/user/reg/payment')" :class="{'on' : progressStyle('/user/reg/payment')}">
                    <a>결제</a>
                </li>
                <li class="pointer" @click="movePage('/user/reg/complete')" :class="{'on' : progressStyle('/user/reg/complete')}">
                    <a>신청완료</a>
                </li>
            </ul>
        </div> -->
        <keep-alive>
            <router-view />
        </keep-alive>
    <!-- </div> -->
</div>
</template>

<script>
export default {
    data: () => ({
        isInit: false
    }),

    watch: {
        // 등록 페이지 내의 현재 라우터 경로 감지
        '$route'(to) {
            this.showProgress(to.fullPath)
        }
    },

    created() {
        this.showProgress(this.$route.fullPath)
    },

    methods: {
        //  URL에 따라서 진행 단계 태그 출력 / 미출력 하기 위함
        showProgress(path) {
            if (path === '/user/reg/init') {
                this.isInit = true
            } else {
                this.isInit = false
            }
        },

        // 수강신청 등록 각 페이지에 대한 css class 적용
        progressStyle(path) {
            if (path === this.$route.fullPath) {
                return true
            } else {
                return false
            }
        },

        // TODO: 페이지 처음 등록시 => 저장한 페이지까지 이동 가능하게 vuex사용
        // TODO: 페이지 이전 데이터 호출시 => 이전에 저장하여 불러온 페이지까지 이동 가능하게 vuex사용
        // 각 등록의 상세 페이지로 라우팅 (데이터 보존 O)
        movePage(path) {
            this.$router.push(path)
        }
    }
}
</script>
